module.exports = __webpack_public_path__ + "img/administrativo.2ef8932a.svg";